var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M23 16h2v18h-2zM23 38h2v2h-2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.889 2.168l20.887 41.773c.703 1.405-.32 3.059-1.89 3.059H3.113C1.54 47 .52 45.346 1.222 43.941L22.109 2.168A2.088 2.088 0 0123.999 1c.75 0 1.5.389 1.89 1.168zM44.885 45c.027 0 .064 0 .097-.054s.017-.087.005-.11L24.1 3.063l-.001-.002C24.083 3.03 24.067 3 23.999 3c-.069 0-.085.03-.101.061l-.001.002L3.01 44.836c-.012.023-.028.056.005.11.034.054.07.054.097.054h41.772z",
    fill: "#000"
  })));
};
export default SvgWarning;